<template>
    <div class="row">
        <!-- <p>{{issueData}}</p> -->
        <div class="col-6">
            <div class="card-blue-xxs">
                <div class="row">
                    <div class="col-12">
                        <p class="text-l text-bold">Total Issue</p>
                    </div>
                    <div class="col-12 mt-20">
                        <p class="text-xxxxl text-bold text-right">
                            {{totalIssue}}
                        </p>
                    </div>
                </div>
                
            </div>

        </div>
        <div class="col-6">
            <div class="row">
                 <div class="col-12">
                    <div class="card-red-xxs">
                        <div class="row">
                            <div class="col-9">
                                <p class="text-m text-bold">Open Issue</p>
                            </div>
                            <div class="col-3">
                                <p class="text-m text-bold">{{openIssue}}</p>
                            </div>
                        </div>
                    </div>
                </div>
                 <div class="col-12">
                    <div class="card-yellow-xxs">
                        <div class="row">
                            <div class="col-9">
                                <p class="text-m text-bold">In Progress</p>
                            </div>
                            <div class="col-3">
                                <p class="text-m text-bold">{{inprogressIssue}}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <div class="card-green-xxs">
                        <div class="row">
                            <div class="col-9">
                                <p class="text-m text-bold">Clossed Issue</p>
                            </div>
                            <div class="col-3">
                                <p class="text-m text-bold">{{closedIssue}}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
</template>

<script>
export default {
    name:"Issue",
    props:["openIssue","closedIssue","inprogressIssue","totalIssue"],
}
</script>


<style scoped>
    .card-blue-xxs{
        height: 100%;
    }
</style>


// WEBPACK FOOTER //
// src/components/Home/Issue.vue